import { render, staticRenderFns } from "./emailHost.vue?vue&type=template&id=3067e755&scoped=true"
import script from "./emailHost.vue?vue&type=script&lang=js"
export * from "./emailHost.vue?vue&type=script&lang=js"
import style0 from "./emailHost.vue?vue&type=style&index=0&id=3067e755&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067e755",
  null
  
)

export default component.exports